import * as React from 'react'
import cn from 'classnames'
import PropTypes from 'prop-types'
import BackgroundImage from 'gatsby-background-image'
import * as grid from 'src/css/grid.module.css'
import * as style from './style.module.css'
export default function Section({
  background,
  children,
  title,
  subtitle,
  small,
  centerTitle,
  className,
  withContainer,
  containerMedium,
  containerSmall,
  withPadding,
}) {
  const sectionClass = cn(
    style.section,
    className && className,
    small && style.small,
    background && style.background,
    withPadding && style.padding
  )

  const containerClass = cn(
    grid.container_no_padding,
    containerMedium && grid.container_med,
    containerSmall && grid.container_small
  )

  const Header = withContainer ? (
    <div className={containerClass}>
      {title && (
        <h2 className={centerTitle && `center`}>{title}</h2>
      )}
      {subtitle && (
        <p
          className={cn(
            style.subtitle,
            centerTitle && `center`
          )}
        >
          {subtitle}
        </p>
      )}
    </div>
  ) : (
    <>
      {title && (
        <h2 className={centerTitle && `center`}>{title}</h2>
      )}
      {subtitle && (
        <p
          className={cn(
            style.subtitle,
            centerTitle && `center`
          )}
        >
          {subtitle}
        </p>
      )}
    </>
  )

  const Content = withContainer ? (
    <div className={containerClass}>{children}</div>
  ) : (
    children
  )
  return background ? (
    <BackgroundImage
      fluid={background}
      className={sectionClass}
    >
      {Header}
      {Content}
    </BackgroundImage>
  ) : (
    <div className={sectionClass}>
      {Header}
      {Content}
    </div>
  )
}

Section.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  small: PropTypes.bool,
  centerTitle: PropTypes.bool,
  withContainer: PropTypes.bool,
  containerSmall: PropTypes.bool,
  background: PropTypes.object,
}
